import { useState, useCallback, useEffect } from "react";

import {
  Row,
  Col,
  Card,
  Button,
  Avatar,
  message,
  Form,
  Space,
  Modal,
} from "antd";

import { VerticalAlignTopOutlined } from "@ant-design/icons";

import BgProfile from "../assets/cms/profile-background-picture.jpg";
import { Checkbox, Input, Select } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import Spinner from "../components/common/Spinner/Spinner";
import CustomSwitch from "../components/common/Switch/CustomSwitch";
import jwtDecode from "jwt-decode";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const companies = [
  { label: "SSG", value: "SSG" },
  { label: "Premium Security", value: "Premium Security" },
  { label: "BGS", value: "BGS" },
];

const functions = [
  { label: "Director", value: "Director" },
  { label: "Inspector", value: "Inspector" },
  { label: "Agent", value: "Agent" },
  { label: "Employee", value: "Employee" },
];

const options = [
  {
    label: "Mega Image",
    value: "Mega Image",
  },
  {
    label: "LSDV",
    value: "LSDV",
  },
  {
    label: "Sly Nutritia",
    value: "Sly Nutritia",
  },
  {
    label: "RER Ecologic",
    value: "RER Ecologic",
  },
  {
    label: "Grupul Tei",
    value: "Grupul Tei",
  },
  {
    label: "Orshar Logistics",
    value: "Orshar Logistics",
  },
  {
    label: "Aquila",
    value: "Aquila",
  },
  {
    label: "Quehenberger Logistics",
    value: "Quehenberger Logistics",
  },
  {
    label: "NEPI",
    value: "NEPI",
  },
  {
    label: "Professional Farmaline",
    value: "Professional Farmaline",
  },
  {
    label: "Pepco",
    value: "Pepco",
  },
  {
    label: "Electromagnetica",
    value: "Electromagnetica",
  },
  {
    label: "Other",
    value: "Other",
  },
];

const possibleActvityTypes = [
  {
    label: "Verificare agenti la schimbul de tura (L-V)",
  },
  {
    label: "Verificare agenti anterior armare (L-V)",
  },
  {
    label: "Verificare agenti la plecare (S-D)",
  },
  {
    label: "Verificare angajati MI la schimb de tura(L-V)",
  },
  {
    label: "Verificare angajati MI anterior armare (L-V)",
  },
  {
    label: "Verificare angajati MI la plecare (S-D)",
  },
  {
    label: "Verificari de noapte agenti /angajati MI",
  },
  {
    label: "Verificari de zi (L-V) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Verificari de zi (S-D) cusete/vestiare/sala mese /zona vanzare",
  },
  {
    label: "Control Politie cu SO direct implicat",
  },
  {
    label: "Participare la oprire pers. suspecte de furt.",
  },
  {
    label: "Participare verificari/analizari prejudicii",
  },
  {
    label: "Raportare eveniment",
  },
  {
    label: "Patrulare/stationare echipaje mobile",
  },
  {
    label: "Solicitare telefonica sef magazin",
  },
  {
    label: "Solicitare telefonica agent securitate",
  },
  {
    label: "Solicitare telefonica CMV",
  },
  {
    label: "Preventie/activitate specifica in afara magazinului",
  },
  {
    label: "Servicii de test",
  },
  {
    label: "Control de zi",
  },
  {
    label: "Control de noapte",
  },
  {
    label: "Armare locatie",
  },
  {
    label: "Dezarmare locatie",
  },
  {
    label: "Verificare buton panica",
  },
  {
    label: "Verificare CCTV",
  },
  {
    label: "Verificare porti senzomatice",
  },
  {
    label: "Instruire personal",
  },
  {
    label: "Mentenanta semestiala",
  },
  {
    label: "Verificare coordonator",
  },
  {
    label: "Patrula",
  },
  {
    label: "Verificari angajati la schimb de tura",
  },
  {
    label: "Verificari angajati la inchidere/plecare",
  },
  {
    label: "Confirmare locatie",
  },
  {
    label: "Asistare la receptie marfa",
  },
];

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

function Profile() {
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const history = useHistory();
  const { id } = useParams();
  // const [imageURL, setImageURL] = useState(false);
  // const [, setLoading] = useState(false);
  // const [items, setItems] = useState(["SSG", "BGS", "Premium Security"]);
  // const [name, setName] = useState("");
  // const [clients, setClients] = useState([]);
  // const [locations, setLocations] = useState([]);

  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingAllLocations, setLoadingAllLocations] = useState(false);
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [company, setCompany] = useState();
  const [clients, setClients] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [email, setEmail] = useState();
  const [restrictions, setRestrictions] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState();
  const [description, setDescription] = useState();
  const [role, setRole] = useState(["ROLE_USER"]);
  const [needsNFC, setNeedsNFC] = useState(true);

  const [companies, setCompanies] = useState([]);
  const [currentCompany, setCurrentCompany] = useState();
  const [loadingCurrentCompany, setLoadingCurrentCompany] = useState(false);

  const [loadingClients, setLoadingClients] = useState(false);
  const [possibleClients, setPossibleClients] = useState([]);

  // const handleChangeRestrictedActivityType = (selectedItems) => {
  //   console.log("Selected Items:", selectedItems);
  // };

  const handleChangeRestrictedActivityType = (value, index) => {
    const updatedRestrictions = [...restrictions];
    updatedRestrictions[index].activityTypes = value;
    setRestrictions(updatedRestrictions);
  };

  const handleAddRestriction = () => {
    setRestrictions([...restrictions, { locationId: "", activityTypes: [] }]);
  };

  const handleDeleteRestriction = (index) => {
    const updatedRestrictions = [...restrictions];
    updatedRestrictions.splice(index, 1);
    setRestrictions(updatedRestrictions);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleOk2 = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Location updated successfully",
    });

    history.push("/users");
  };
  const successDelete = () => {
    messageApi.open({
      type: "success",
      content: "Location deleted successfully",
    });

    history.push("/users");
  };
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Something went wrong. Please try again later.",
    });
  };

  const availableLocations = locations?.map((location) => {
    return {
      label: location.locationName,
      value: location.id,
    };
  });

  const deleteUser = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + `user/deleteUser?userId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setIsModalOpen(false);
      successDelete();
      history.push("/users");
    } catch (error) {
      setIsModalOpen(false);
      console.log(error);
      error();
    }
  };

  const getLocationsByClient = async (clients) => {
    const myArray = [];
    for (const client of clients) {
      const token = localStorage.getItem("token");
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL +
            `location/getAllLocationsByClient?client=${client}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);
        myArray.push(...response.data);
        console.log("myArray: ", myArray);
        setLocations(myArray);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getCompanies = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "company/getAllCompanies",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setCompanies(response?.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange2 = useCallback(
    (item) => {
      setClients(item);
      setLocations([]);
      setSelectedLocations([]);
      console.log(item);

      getLocationsByClient(item);
    },

    [locations, clients]
  );

  const handleChange3 = (item) => setSelectedLocations(item);

  const societatiPaza = [
    {
      label: "AKB SECURITY",
      value: "AKB SECURITY",
    },
    {
      label: "ELNET SECURITY",
      value: "ELNET SECURITY",
    },
    {
      label: "ORION SECURITY",
      value: "ORION SECURITY",
    },
    {
      label: "RPG SECURITY",
      value: "RPG SECURITY",
    },
    {
      label: "SSG SECURITY",
      value: "SSG SECURITY",
    },
    {
      label: "SSG FIRE&RESCUE",
      value: "SSG FIRE&RESCUE",
    },
    {
      label: "HIGHLANDER GUARD",
      value: "HIGHLANDER GUARD",
    },
  ];

  const handleChange4 = (item) => {
    setCompany(item);
    console.log(item);
  };

  // const handleChange3 = useCallback(
  //   (item) => {
  //     setSelectedLocations(item);
  //     console.log(item);
  //     // setClients(item);
  //     getLocationsByClient(item);
  //   },
  //
  //   [locations, clients]
  // );

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const getCompany = async (id) => {
    const token = localStorage.getItem("token");
    try {
      setLoadingData(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `company/getCompany?companyId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);

      setCurrentCompany(response?.data);
      // setPassword(response.data.password);
      // setConfirmPassword(response.data.password);
      // setCompany(response.data.company);
      // setClients(response.data.clients);
      // setSelectedLocations(response.data.locationList);
      // setEmail(response.data.email);
      // setPhoneNumber(response.data.phoneNumber);
      // setDescription(response.data.description);
      // setRole(response.data.roles);
      // setNeedsNFC(response.data.needsNFC);

      setLoadingData(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getUser = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingData(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `user/getUser?userId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);

      setUsername(response?.data?.username);
      // setPassword(response.data.password);
      // setConfirmPassword(response.data.password);
      setCompany(response?.data?.company);
      setClients(response?.data?.clients);
      setSelectedLocations(response?.data?.locationList);
      setEmail(response?.data?.email);
      setRestrictions(response?.data?.restrictions ?? []);
      setPhoneNumber(response?.data?.phoneNumber);
      setDescription(response?.data?.description);
      setRole(response?.data?.roles);
      setNeedsNFC(response?.data?.needsNFC);

      // try {
      //   setLoadingData(true);

      const response2 = await axios.get(
        process.env.REACT_APP_API_URL +
          `company/getCompany?companyId=${response?.data?.company}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      setCurrentCompany(response2?.data);
      // setPassword(response.data.password);
      // setConfirmPassword(response.data.password);
      // setCompany(response.data.company);
      // setClients(response.data.clients);
      // setSelectedLocations(response.data.locationList);
      // setEmail(response.data.email);
      // setPhoneNumber(response.data.phoneNumber);
      // setDescription(response.data.description);
      // setRole(response.data.roles);
      // setNeedsNFC(response.data.needsNFC);

      //   setLoadingData(false);
      // } catch (error) {
      //   console.log(error);
      // }

      setLoadingData(false);
    } catch (error) {
      console.log(error);
      setLoadingData(false);
    }
  };

  const updateUser = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");
    console.log(role);
    console.log(confirmPassword);
    if (
      username &&
      // password &&
      // confirmPassword &&
      role &&
      company &&
      clients &&
      selectedLocations
    ) {
      try {
        const response = await axios.put(
          process.env.REACT_APP_API_URL + `user/updateUser?userId=${id}`,
          {
            id: id,
            email: email,
            username: username,
            // password: password,
            roles: role,
            company: company,
            clients: clients,
            locationList: selectedLocations,
            restrictions: restrictions,
            phoneNumber: phoneNumber,
            description: description,
            needsNFC: needsNFC,
            avatar: "avatar",
            active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        success();
      } catch (e) {
        console.log(e);
        error(e.response.data.reason);
      }
    }
  };

  const changePassword = async () => {
    // console.log("onFinish called");
    const token = localStorage.getItem("token");
    console.log(role);
    console.log(confirmPassword);
    if (
      // username &&
      password &&
      confirmPassword
      // role &&
      // company &&
      // clients &&
      // selectedLocations
    ) {
      try {
        const response = await axios.put(
          process.env.REACT_APP_API_URL + `user/changeUserPassword`,
          {
            userId: id,
            // email: email,
            // username: username,
            password: password,
            // roles: role,
            // company: company,
            // clients: clients,
            // locationList: selectedLocations,
            // phoneNumber: phoneNumber,
            // description: description,
            // needsNFC: needsNFC,
            // avatar: "avatar",
            // active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        success();
      } catch (e) {
        console.log(e);
        error(e.response.data.reason);
      }
    }
  };

  const getLocations = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingAllLocations(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "location/getAllLocations",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setAllLocations(response?.data);
      setLoadingAllLocations(false);
    } catch (error) {
      console.log(error);
    }
  };

  const initialClients = clients?.map((client) => {
    return {
      label: client,
      value: client,
    };
  });

  const initialLocations = allLocations.filter((o1) =>
    selectedLocations?.some((o2) => o1.id === o2)
  );

  const addItem = (newItem) => {
    setClients([...clients, newItem]);
  };

  // Step 3: Function to remove an item from the array
  const removeItem = (itemToRemove) => {
    setClients(clients.filter((item) => item !== itemToRemove));

    setSelectedLocations((prevSelectedLocations) =>
      prevSelectedLocations.filter((locationID) => {
        const location = allLocations.find((loc) => loc.id === locationID);
        return location.client !== itemToRemove;
      })
    );
  };

  const addItem3 = (newItem) => {
    setSelectedLocations([...selectedLocations, newItem]);
  };

  // Step 3: Function to remove an item from the array
  const removeItem3 = (itemToRemove) => {
    setSelectedLocations(
      selectedLocations.filter((item) => item !== itemToRemove)
    );
  };

  const handleCheckboxChange2 = (event, item) => {
    if (event.target.checked) {
      // Checkbox is checked, add the item
      addItem(item);
    } else {
      // Checkbox is unchecked, remove the item
      removeItem(item);
    }
  };

  const handleCheckboxChange3 = (locationId) => {
    setSelectedLocations((prevSelectedLocations) => {
      // Check if the locationId is already in the selectedLocations array
      const isSelected = prevSelectedLocations.includes(locationId);

      // If it's selected, remove it; if it's not selected, add it
      if (isSelected) {
        return prevSelectedLocations.filter((id) => id !== locationId);
      } else {
        return [...prevSelectedLocations, locationId];
      }
    });
  };

  const getClients = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingClients(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "clients/getAllClients",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setPossibleClients(response.data);
      setLoadingClients(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    getUser();
    getLocations();
    getCompanies();
  }, []);

  // useEffect(() => {
  //   getCompany(company);
  // }, []);

  return (
    <>
      {contextHolder}

      <div
        className="profile-nav-bg"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      ></div>

      {loadingAllLocations || loadingData ? (
        <Spinner />
      ) : (
        <>
          <Card
            className="card-profile-head"
            bodyStyle={{ display: "none" }}
            title={
              <Row justify="space-between" align="middle" gutter={[24, 0]}>
                <Col span={24} md={12} className="col-info">
                  <Avatar.Group>
                    {/*<Avatar size={74} shape="square" src={profilavatar} />*/}

                    <div className="avatar-info">
                      <h4 className="font-semibold m-0">{username}</h4>
                    </div>
                  </Avatar.Group>
                </Col>
                <Col
                  span={24}
                  md={12}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <h1>{currentCompany?.companyName}</h1>
                </Col>
              </Row>
            }
          ></Card>

          <Card
            bordered={false}
            className="header-solid mb-24"
            title={
              <>
                <h6 className="font-semibold">Edit User</h6>
                <p>Edit user information below</p>
              </>
            }
          >
            <Row
              style={{
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              <Form
                {...formItemLayout}
                form={form}
                name="register"
                onFinish={onFinish}
                style={{
                  width: "80%",
                }}
                scrollToFirstError
              >
                {/*TODO USERNAME*/}
                {/*<Form.Item*/}
                {/*  name="username"*/}
                {/*  label="Username"*/}
                {/*  initialValue={username}*/}
                {/*  tooltip="Please provide a username"*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: true,*/}
                {/*      message: "Please input the username!",*/}
                {/*      whitespace: true,*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Input*/}
                {/*    value={username}*/}
                {/*    onChange={(e) => setUsername(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="password"*/}
                {/*  label="Password"*/}
                {/*  initialValue={password}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: true,*/}
                {/*      message: "Please input the user password!",*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*  hasFeedback*/}
                {/*>*/}
                {/*  <Input.Password*/}
                {/*    value={password}*/}
                {/*    onChange={(e) => setPassword(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="confirm"*/}
                {/*  label="Confirm Password"*/}
                {/*  initialValue={password}*/}
                {/*  dependencies={["password"]}*/}
                {/*  hasFeedback*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: true,*/}
                {/*      message: "Please confirm the user password!",*/}
                {/*    },*/}
                {/*    ({ getFieldValue }) => ({*/}
                {/*      validator(_, value) {*/}
                {/*        if (!value || getFieldValue("password") === value) {*/}
                {/*          return Promise.resolve();*/}
                {/*        }*/}
                {/*        return Promise.reject(*/}
                {/*          new Error(*/}
                {/*            "The two passwords that you entered do not match!"*/}
                {/*          )*/}
                {/*        );*/}
                {/*      },*/}
                {/*    }),*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Input.Password*/}
                {/*    value={confirmPassword}*/}
                {/*    onChange={(e) => setConfirmPassword(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                <Form.Item
                  name="company"
                  label="Company"
                  tooltip="Please specify a company"
                  initialValue={loadingData ? "" : currentCompany?.companyName}
                  rules={[
                    {
                      required: currentCompany?.companyName ? null : true,
                      message: "Please input the company!",
                      // whitespace: true,
                    },
                  ]}
                >
                  <Space
                    style={{
                      width: "100%",
                    }}
                    direction="vertical"
                  >
                    <Select
                      mode="single"
                      style={{
                        width: "100%",
                      }}
                      placeholder="Please select"
                      defaultValue={
                        loadingData ? "" : currentCompany?.companyName
                      }
                      onChange={handleChange4}
                      options={companies?.map((company) => {
                        return {
                          label: company.companyName,
                          value: company.id,
                        };
                      })}
                    />
                  </Space>
                </Form.Item>

                <Form.Item
                  name="clients"
                  label="Clients"
                  // initialValue={clients.map((client) => {
                  //   return { label: client, value: client };
                  // })}
                  initialValue={initialClients}
                  tooltip="Please specify at least one client"
                  rules={[
                    {
                      required: false,
                      message: "Please input the clients!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Space
                    style={{
                      width: "100%",
                    }}
                    direction="vertical"
                  >
                    {/*<Select*/}
                    {/*  mode="multiple"*/}
                    {/*  style={{*/}
                    {/*    width: "100%",*/}
                    {/*  }}*/}
                    {/*  placeholder="Please select"*/}
                    {/*  defaultValue={initialClients}*/}
                    {/*  // defaultValue={clients}*/}
                    {/*  onChange={handleChange2}*/}
                    {/*  options={options}*/}
                    {/*/>*/}
                    {possibleClients.map((option) => (
                      <Checkbox
                        checked={clients?.includes(option?.name)}
                        onChange={(e) => handleCheckboxChange2(e, option?.name)}
                      >
                        {option.name}
                      </Checkbox>
                    ))}
                  </Space>
                  {/*<span>*/}
                  {/*  <span style={{ textDecoration: "underline" }}>*/}
                  {/*    Current clients*/}
                  {/*  </span>*/}
                  {/*  :{" "}*/}
                  {/*  {initialClients?.map((client) => {*/}
                  {/*    return <span>{client.label}; </span>;*/}
                  {/*  })}*/}
                  {/*</span>*/}
                </Form.Item>

                <Form.Item
                  name="locations"
                  label="Locations"
                  // initialValue={selectedLocations}
                  tooltip="Please specify at least one location"
                  rules={[
                    {
                      required: false,
                      message: "Please input the locations!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Space
                    style={{
                      width: "100%",
                    }}
                    direction="vertical"
                  >
                    {loading ? (
                      <Spinner height="auto" size="default" />
                    ) : (
                      // <Select
                      //   mode="multiple"
                      //   allowClear
                      //   style={{
                      //     width: "100%",
                      //   }}
                      //   placeholder="Please select"
                      //   value={initialLocations?.map((location) => {
                      //     return {
                      //       label: location?.locationName,
                      //       value: location?.id,
                      //     };
                      //   })}
                      //   // defaultValue={initialLocations.map((location) => {
                      //   //   return {
                      //   //     label: location.locationName,
                      //   //     value: location.id,
                      //   //   };
                      //   // })}
                      //   onChange={handleChange3}
                      //   options={availableLocations}
                      // />

                      allLocations.map((location) => (
                        <Checkbox
                          checked={selectedLocations.includes(location.id)}
                          onChange={() => handleCheckboxChange3(location.id)}
                          disabled={!clients.includes(location?.client)}
                        >
                          {location?.locationName}
                        </Checkbox>
                      ))

                      // JSON.stringify(
                      //   allLocations.filter((o1) =>
                      //     selectedLocations?.some((o2) => o1.id === o2)
                      //   ),
                      //   null,
                      //   4
                      // )
                    )}
                  </Space>
                  {/*<span>*/}
                  {/*  <span style={{ textDecoration: "underline" }}>*/}
                  {/*    Current Locations*/}
                  {/*  </span>*/}
                  {/*  :{" "}*/}
                  {/*  {initialLocations?.map((location) => {*/}
                  {/*    return <span>{location.locationName}; </span>;*/}
                  {/*  })}*/}
                  {/*</span>*/}
                </Form.Item>

                {/*TODO EMAIL*/}
                {/*<Form.Item*/}
                {/*  name="email"*/}
                {/*  label="E-mail"*/}
                {/*  initialValue={email}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      type: "email",*/}
                {/*      message: "The input is not valid E-mail!",*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Input*/}
                {/*    value={email}*/}
                {/*    onChange={(e) => setEmail(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<div>*/}
                {/*  <Form.Item*/}
                {/*    name="restrictionLocation"*/}
                {/*    label="Restriction Location"*/}
                {/*    initialValue={undefined}*/}
                {/*    // rules={}*/}
                {/*  >*/}
                {/*    <Select*/}
                {/*      // defaultValue="ROLE_USER"*/}
                {/*      showSearch={true}*/}
                {/*      optionFilterProp="label"*/}
                {/*      placeholder="Select the restriction location"*/}
                {/*      value={role}*/}
                {/*      options={allLocations?.map((location) => ({*/}
                {/*        value: location.id,*/}
                {/*        label: location.locationName,*/}
                {/*      }))}*/}
                {/*      onChange={(value) => setRole([value])}*/}
                {/*    />*/}
                {/*  </Form.Item>*/}

                {/*  <Form.Item*/}
                {/*    name="restriction activity types"*/}
                {/*    label="Restricted activity types"*/}
                {/*    initialValue={undefined}*/}
                {/*    // rules={}*/}
                {/*  >*/}
                {/*    <Select*/}
                {/*      mode="multiple"*/}
                {/*      showSearch*/}
                {/*      placeholder="Select restricted activity types"*/}
                {/*      optionFilterProp="children"*/}
                {/*      style={{ width: "100%" }}*/}
                {/*      onChange={handleChangeRestrictedActivityType}*/}
                {/*    >*/}
                {/*      {possibleActvityTypes.map((activity) => (*/}
                {/*        <Option key={activity.label} value={activity.label}>*/}
                {/*          {activity.label}*/}
                {/*        </Option>*/}
                {/*      ))}*/}
                {/*    </Select>*/}
                {/*  </Form.Item>*/}
                {/*</div>*/}

                <Form.Item
                  initialValue={phoneNumber}
                  name="phone"
                  label="Phone Number"
                >
                  <Input
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    style={{
                      width: "100%",
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="intro"
                  label="Description"
                  initialValue={description}
                  rules={[
                    {
                      required: false,
                      message: "Please input Description",
                    },
                  ]}
                >
                  <Input.TextArea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    showCount
                    maxLength={100}
                  />
                </Form.Item>

                <Form.Item
                  name="role"
                  label="Role"
                  initialValue={role}
                  rules={[
                    {
                      required: true,
                      message: "Please select role!",
                    },
                  ]}
                >
                  <Select
                    defaultValue="ROLE_USER"
                    placeholder="Select the role"
                    value={role}
                    options={[
                      { value: "ROLE_USER", label: "User" },
                      { value: "ROLE_ADMIN", label: "Admin" },
                    ]}
                    onChange={(value) => setRole([value])}
                  />
                </Form.Item>

                <Form.Item label="Needs NFC" initialValue={needsNFC}>
                  <CustomSwitch
                    checked={needsNFC}
                    onChange={(e) => setNeedsNFC(e)}
                  />
                </Form.Item>

                {/*RESTRICTIONS*/}
                <div>
                  <Form.Item {...tailFormItemLayout}>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "16px",
                      }}
                    >
                      {/*<p>Restrictions:</p>*/}
                      <Button onClick={handleAddRestriction}>
                        Add Restriction
                      </Button>
                    </div>
                  </Form.Item>
                  {restrictions?.map((restriction, index) => (
                    <div key={index}>
                      <Form.Item
                        label={`Restriction Location ${index + 1}`}
                        initialValue={restriction.locationId}
                      >
                        <Select
                          showSearch
                          placeholder="Select the restriction location"
                          optionFilterProp="children"
                          value={restriction.locationId}
                          onChange={(value) => {
                            const updatedRestrictions = [...restrictions];
                            updatedRestrictions[index].locationId = value;
                            setRestrictions(updatedRestrictions);
                          }}
                        >
                          {allLocations?.map((location) => (
                            <Option
                              key={location.id}
                              value={location.id}
                              label={location.locationName}
                            >
                              {location.locationName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        label={`Restricted Activity Types ${index + 1}`}
                        initialValue={restriction.activityTypes}
                      >
                        <Select
                          mode="multiple"
                          showSearch
                          placeholder="Select restricted activity types"
                          optionFilterProp="children"
                          style={{ width: "100%" }}
                          value={restriction.activityTypes}
                          onChange={(value) =>
                            handleChangeRestrictedActivityType(value, index)
                          }
                        >
                          {possibleActvityTypes.map((activity) => (
                            <Option key={activity.label} value={activity.label}>
                              {activity.label}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                          marginBottom: "16px",
                        }}
                      >
                        <span
                          style={{
                            color: "red",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={() => handleDeleteRestriction(index)}
                        >
                          Delete Restriction
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <Form.Item {...tailFormItemLayout}>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    type="secondary"
                    className="tag-primary"
                    htmlType="submit"
                    onClick={() => updateUser()}
                  >
                    Update User
                  </Button>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    onClick={() => showModal2()}
                    type="info"
                  >
                    Change User Password
                  </Button>
                  <Modal
                    title="Warning"
                    open={isModalOpen2}
                    okText="Change Password"
                    okType="danger"
                    onOk={changePassword}
                    onCancel={handleCancel2}
                  >
                    <>
                      {" "}
                      <Form.Item
                        name="password"
                        label="Insert Password"
                        initialValue={password}
                        rules={[
                          {
                            required: true,
                            message: "Please input the user password!",
                          },
                        ]}
                        hasFeedback
                      >
                        <Input.Password
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </Form.Item>
                      <Form.Item
                        name="confirm"
                        label="Confirm Password"
                        initialValue={password}
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: "Please confirm the user password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "The two passwords that you entered do not match!"
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </Form.Item>
                    </>
                  </Modal>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    onClick={() => showModal()}
                    type="danger"
                  >
                    DELETE User
                  </Button>
                  <Modal
                    title="Warning"
                    open={isModalOpen}
                    okText="Delete"
                    okType="danger"
                    onOk={deleteUser}
                    onCancel={handleCancel}
                  >
                    <p>Are you sure you want do delete this user?</p>
                  </Modal>
                </Form.Item>
              </Form>
            </Row>
          </Card>
        </>
      )}
    </>
  );
}

export default Profile;
